import {action} from 'easy-peasy';
import {WEBSOCKET_STATUS} from 'services/WebSocketApi';

export default {
  status: WEBSOCKET_STATUS.CLOSED,

  updateStatus: action((state, status) => {
    state.status = status;
  }),
};
